import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'


import { alertRoutine } from '../../../redux/Alerts/routines'
import schema from './taskFormSchema'

import { store, i18n } from '../../../index'
import { useSelector, useDispatch } from 'react-redux'

import { useTranslation } from 'react-i18next';


import { Box, Button, Link, Paper, Popper, Table, TableBody, TableCell, TableRow, TextField } from '@material-ui/core';
import moment from 'moment';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import { useForm, useController } from "react-hook-form";
import { useUserArrayParam } from '../../../utils/hooks';
import CloseIcon from '@material-ui/icons/Close';
import { MuiPickersContext, Calendar, useKeyboardPickerState } from '@material-ui/pickers';
import { AssignmentLateOutlined, AssignmentTurnedInOutlined } from '@material-ui/icons';
import KeyboardDateInput from '@material-ui/pickers/_shared/KeyboardDateInput';
import { makePatientSelector, makeSearchPatientsSelector, patientsIsLoadingSelector } from '../../../redux/Patients/selectors';
import { collectionKeysEqualityFn, objectKeysEqualityFn } from '../../../utils/equality';
import { searchPatientsRoutine } from '../../../redux/Patients/routines';
import Highlighter from 'react-highlight-words';
import { deleteTaskRoutinePromiseCreator, postTaskRoutinePromiseCreator, putTaskRoutinePromiseCreator } from '../../../redux/Tasks/routines';
import theme from '../../../utils/theme';
import { AjvValidatorContext } from '../../../utils/context/AjvContext';
import { lateTaskSelector, tasksPatientSelector } from '../../../redux/Tasks/selectors';
import { v4 } from 'uuid';
import { useKeyPress } from 'react-use';
import { formatDuration } from '../../../utils/string-helpers';
import CustomSelectTextField from '../../Correspondants/MenuTextField';


const OptionItem = ({ handleRemove, title}) => {
  const [hover, setHover] = useState(false)
  return (
    <Box display={"flex"} flex={1} position="relative" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Box flex={1}>{title}</Box>
      <Box marginRight={2}>
        {
          hover &&
          <IconButton size="small" style={{padding: 0, position: 'absolute', top: '50%', transform:'translateY(-50%)'}} onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            handleRemove()
          }}>
            <CloseIcon />
          </IconButton>
        }
      </Box>
    </Box>
  )
} 

const filter = createFilterOptions();

export default function ParamAutocompleteField({
  type = "", 
  name, 
  control, 
  label, 
  variant, 
  size,
  fullWidth,
  disabled
}) {
  
  const {t} = useTranslation()
  const [params, handleAdd, handleRemove] = useUserArrayParam(type)

  const {
    field: { onChange, value },
    fieldState: { invalid, isTouched, isDirty, error},
    formState: { touchedFields, dirtyFields}
  } = useController({
    name,
    control,
    defaultValue: null,
  });

  useEffect(() => {
    if(!value || params.includes(value))
      return
      handleAdd(value)
  }, [value])

  const [inputValue, setInputValue] = useState('')
  
  return (
    <Autocomplete
      size={size}
      value={value || null}
      onChange={(event, newValue) => {
        if (newValue?.inputValue) {
          onChange(newValue.inputValue);
        }
        else {
          onChange(newValue)
        }
      }}
      filterOptions={(options, filterParams) => {
        const filtered = filter(options, filterParams);

        // Suggest the creation of a new value
        if (filterParams.inputValue !== '' && !params.includes(filterParams.inputValue)) {
          filtered.push({
            inputValue: filterParams.inputValue,
            name: `${t('common:interface.add')} "${filterParams.inputValue}"`,
          });
        }

        return filtered;
      }}
      selectOnFocus
      //clearOnBlur
      forcePopupIcon
      openOnFocus
      options={params}
      getOptionLabel={(option) => {
        //console.log('getOptionLabel', option)
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option && option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        //return option.name;
      }}
      renderOption={(option) => params.includes(option) ? <OptionItem title={typeof option === 'string' ? option :  option && option.name ? option.name : ""} handleRemove={() => handleRemove(params.indexOf(option))} /> : typeof option === 'string' ? option :  option && option.name ? option.name : ""}
      //style={{ width: 300 }}
      freeSolo
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      blurOnSelect
      disabled={disabled}
      renderInput={(p) => (
        <TextField 
          {...p} 
          label={label} variant={variant} 
          name={name} // send down the input name
          fullWidth={fullWidth}
          error={Boolean(error)}
          helperText={error?.message}
          onBlur={e => {
            if(inputValue && inputValue !== value) {
              if(value)
                setInputValue(value)
              else
                setInputValue('')
            }
          }}
        />
      )}
    />
  );
}

const HighlightTag = (({ children, highlightIndex }) => <Box children={children} color="secondary.main" component="span"/>)

function PatientItem({firstname, lastname, query}) {
  return (
    <div>
      <Highlighter
        //highlightClassName="text-highlight"
        highlightTag={HighlightTag}
        searchWords={query.split(' ')}
        autoEscape={true}
        textToHighlight={`${firstname} ${lastname}`}
        sanitize={(text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()}
      />
    </div>
  )
}

function PatientAutocompleteField({
  name, 
  control, 
  label, 
  variant, 
  size,
  fullWidth,
  disabled,
}) {
  
  const dispatch = useDispatch()
  const {
    field: { onChange, value },
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields }
  } = useController({
    name,
    control,
    defaultValue: null,
  });

  const [inputValue, setInputValue] = React.useState('');
  const searchPatientsSelector = useMemo(makeSearchPatientsSelector, [])
  const patients = useSelector(searchPatientsSelector, collectionKeysEqualityFn(['id', 'updatedAt']))
  const loading = useSelector(patientsIsLoadingSelector)
  const patientSelector = useMemo(makePatientSelector, []);
  const patient = useSelector(state => patientSelector(state, value), objectKeysEqualityFn(['id', 'updatedAt']));

  // const patientRef = useRef()
  // useEffect(() => {
  //   console.log("patient change", objectKeysEqualityFn(['id', 'updatedAt'])(patientRef.current, patient))
  //   patientRef.current = patient
  // }, [patient])



  useEffect(() => {
    //if(inputValue.length)
      dispatch(searchPatientsRoutine.trigger({search: inputValue || ' '}))
    //else
      //dispatch(searchPatientsRoutine.clear())
  },[inputValue])

  return (
    <Autocomplete
      value={value || null}
      onChange={(event, newValue) => {
        console.log('onChange', newValue)
        onChange(newValue?._id || null)
      }}
      options={patients}
      getOptionLabel={(option) => (typeof option === 'string' ? patient? `${patient.firstname} ${patient.lastname}` : '' : `${option.firstname} ${option.lastname}`)}
      filterOptions={(x) => x}
      autoComplete
      includeInputInList
      //filterSelectedOptions
      getOptionSelected={(option, value) => {
        return option._id === value
      }}
      loading={loading}
      renderOption={(option, { inputValue }) => {
        return <PatientItem firstname={option.firstname} lastname={option.lastname} query={inputValue}/>
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          fullWidth={fullWidth}
          size={size}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  )
}

export function EcheanceDateInput2({
  control,
  className,
  name,
  label,
  variant,
  margin,
  fullWidth,
  //autoOk,
  disabled,
  disableFuture,
  disablePast = true,
  dateFormat,
  //id,
  required,
  initialValue,
  size,
  // Presets à DATE ABSOLUE (optionnel) : [{ label, getDate: () => moment|null }].
  // Si fourni, remplace les raccourcis relatifs (+1 semaine, etc.) par ces presets.
  absoluteShortcuts,
  ...other
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { invalid, isTouched, isDirty, error},
  } = useController({
    name,
    control,
    defaultValue: initialValue,
  });
  
  const {t} = useTranslation()
  const { moment } = useContext(MuiPickersContext);
  const autoOk = useRef(true)

  const format = moment.localeData().longDateFormat('L')

  //const [inputValue, setInputValue] = useState(value)

  const { inputProps, pickerProps, wrapperProps } = useKeyboardPickerState({
    value: value,
    onChange: (date, value) => {
      console.log('onChange', date, value)
      //onChange(date.format('YYYY-MM-DD'))
      onChange(date && date.isValid() ? date.format('YYYY-MM-DD') : value)
      if(autoOk.current)
        setAnchorEl(null)
      autoOk.current = true;
    },
    autoOk: true,
    format,
    disablePast,
  });

  //const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(anchorEl ? null : event.currentTarget);
  // };

  // const open = Boolean(anchorEl);
  // const id = open ? 'simple-popper' : undefined;


  const handleAdd = (count, type) => () => {
    autoOk.current = false;
    pickerProps.onChange(pickerProps.date.clone().add(count, type))  
    //onChange(pickerProps.date.clone().add(count, type).format('YYYY-MM-DD'))   
  }

  const setToday = () => {
    autoOk.current = false;
    pickerProps.onChange(moment())
  }

  // Applique un preset à date absolue (ex. « 15 jours avant la date de début de période »).
  // autoOk = true → la date est VALIDÉE et le picker se ferme au clic (contrairement aux
  // raccourcis relatifs qui restent ouverts pour être enchaînés).
  const handleSetAbsolute = (getDate) => () => {
    const d = typeof getDate === 'function' ? getDate() : null;
    if (d && d.isValid && d.isValid()) {
      autoOk.current = true;
      pickerProps.onChange(d);
    }
  }

  const shortcuts = useMemo(() => ([
    { count: 1, key: 'weeks'},
    { count: 2, key: 'weeks'},
    { count: 1, key: 'months'},
    { count: 3, key: 'months'},
    { count: 6, key: 'months'},
    { count: 1, key: 'years'},
  ]), [])

  const altShortcuts = useMemo(() => ([
    { count: -1, key: 'weeks'},
    { count: -2, key: 'weeks'},
    { count: -1, key: 'months'},
    { count: -3, key: 'months'},
    { count: -6, key: 'months'},
    { count: -1, key: 'years'},
  ]), [])

  const [optionPressed] = useKeyPress('Alt')
  
  const duration = moment.duration(moment(value).startOf('day').diff(moment().startOf('day')))
  console.log('duration', duration)
  return (
    <div>
      <KeyboardDateInput 
        {...inputProps}
        size={size}
        format={format}
        inputRef={ref}
        onBlur={onBlur}
        fullWidth={fullWidth}
        inputVariant={variant}
        openPicker={(e) => {
          setAnchorEl(e.currentTarget)
        }}
        className={className}
        helperText={error?.message}
        error={Boolean(error)}
        disabled={disabled}
        label={label}
      />
      {/* <TextField
        onBlur={onBlur}
        fullWidth={fullWidth}
        inputRef={ref}
        ref={anchorEl}
        onFocus={inputProps.openPicker}
        value={inputProps.inputValue}
        InputProps={{
          endAdornment:
            <InputAdornment position="end">
              <IconButton
                onClick={() => setOpen(true)}
              >
                <CalendarToday/>
              </IconButton>
            </InputAdornment>
          
        }}
      /> */}
      <Popper id="calendar-popper" open={Boolean(anchorEl)} anchorEl={anchorEl} style={{ zIndex: 1500 }} placement="bottom-end">
        <Box component={Paper} display="flex" elevation={1} >
          <Box overflow={"hidden"} padding={1} display="flex" 
            flexDirection="column"
            alignItems="flex-start">
            <Box>
              <Calendar 
                {...pickerProps}
                disablePast={disablePast}
                disableFuture={disableFuture}
              />
            </Box>
            <Box flexGrow={1}/>
            <Box>
              {
                (duration.asDays() >= 1 || duration.asDays() <= -1) &&
                formatDuration(moment(value).startOf('day'))
              }
            </Box>
          </Box>
          <Box 
            display="flex" 
            flexDirection="column"
            alignItems="flex-start"
            padding={2}
          > 
            {(absoluteShortcuts && absoluteShortcuts.length) ? (
              absoluteShortcuts.map((shortcut, i) => (
                <Link
                  key={shortcut.label || i}
                  component="button"
                  variant="body1"
                  onClick={handleSetAbsolute(shortcut.getDate)}
                  underline="none"
                >
                  {shortcut.label}
                </Link>
              ))
            ) : (
              <>
                <Link
                  component="button"
                  variant="body1"
                  onClick={setToday}
                  underline="none"
                >
                  {t(`common:button.today`)}
                </Link>
                {
                  (optionPressed ? altShortcuts : shortcuts).map(shortcut => (
                    <Link
                      key={`${shortcut.count}-${shortcut.key}`}
                      component="button"
                      variant="body1"
                      onClick={handleAdd(shortcut.count, shortcut.key)}
                      underline="none"
                    >
                      {shortcut.count > 0 ? '+' : shortcut.count < 0 ? '-' : ''} {t(`common:interface.${shortcut.key.slice(0, -1)}`, {count: Math.abs(shortcut.count)})}
                    </Link>
                  ))
                }
              </>
            )}
            <Box flexGrow={1}/>
            <Box alignSelf="end">
              <Button color="primary" onClick={() => setAnchorEl(null)}>{t('common:button.ok')}</Button>
            </Box>
          </Box>
        </Box>
      </Popper>
      
    </div> 
  )
}

const useStyles = makeStyles( theme => ({
  buttonTextField: {
    "& .MuiInputAdornment-root button": {
      marginRight: -12
    }
  }
}));

const Form = ({ submitRef = {}, task,  ...rest}) => {
  
  const classes = useStyles();
  
  
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const { ajvResolver } = React.useContext(AjvValidatorContext);

  const { register, handleSubmit, control, formState: { errors },} = useForm({
    defaultValues: {
      booklet: task.booklet || '',
      due_date: task.due_date || moment().format('YYYY-MM-DD'),
      parent_patient: task.parent_patient || '',
      task_owner: task.task_owner || '',
      note: task.note || '',
    },
    resolver: ajvResolver(schema)
  });
  

  submitRef.current =  async () => {
    let dataRef;
    await handleSubmit(async (data) => {
      if(!data.parent_patient)
        delete data.parent_patient
      if(!data.task_owner)
        delete data.task_owner
      dataRef = data;
    })()
    return dataRef;
  }
  

  return (
    <form style={{display: 'flex', position: 'relative'}}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ParamAutocompleteField 
            name="booklet" 
            control={control} 
            margin="dense" 
            type="task-booklet"
            variant="outlined"
            size="small"
            label={t('task.booklet')}
            fullWidth
            disabled={Boolean(task.done)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EcheanceDateInput2 
            name="due_date" 
            control={control}
            size="small" 
            label={t('task.due_date')}
            disablePast
            variant="outlined"
            fullWidth
            className={classes.buttonTextField}
            disabled={Boolean(task.done)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PatientAutocompleteField
            variant="outlined" 
            size="small" 
            fullWidth
            name="parent_patient" 
            control={control}
            label={t('task.patient')}
            disabled={Boolean(task.done)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomSelectTextField
            variant="outlined"
            size="small"
            fullWidth
            name="task_owner"
            control={control}
            type="task-owner"
            label={t('task.owner')}
            disabled={Boolean(task.done)}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField 
            {...register('note')} 
            multiline 
            minRows={3} 
            variant="outlined" 
            size="small" 
            fullWidth
            label={t('task.note')}
            error={Boolean(errors.note)}
            helperText={errors?.note?.message}
            disabled={Boolean(task.done)}
          />
        </Grid>
      </Grid>
    </form>
  )
}

const errorActionCreator = () => (
  alertRoutine.show({
    type: 'snack',
    title: i18n.t('common:interface.an error occured'),
    severity: 'error'
  })
)

export const taskFormActionCreator = (task = {}, parentAlertId) => {
  
  const submitRef = { current: (x) => console.log('old submit') }

  return (
    alertRoutine.show({
      type: 'dialog',
      maxWidth: 'sm',
      parent: parentAlertId,
      title: task && task.id ? task.done ? i18n.t('tasks.View task') : i18n.t('tasks.Edit task') : i18n.t('tasks.Add task'),
      content: <Form submitRef={submitRef} task={task}/>,
      fullScreenSmallScreen: true,
      scroll: 'body',
      disableEnforceFocus: true,
      secondaryActions: task?.id && [
        {
          title: i18n.t('common:button.delete'),
          color: theme().palette.error.main,
          action: (parentAlertId) => store.dispatch(deleteTaskFormActionCreator(task, parentAlertId))
        },
        ...(task.done ? [] : [ 
          {
          title: i18n.t('common:button.done'),
          color: theme().palette.success.main,
          action: async (parentAlertId, { progress, reject }) => { 
            try {
              progress.handleTrigger()

              if(task && task.id) {
                await putTaskRoutinePromiseCreator({
                  id: task.id,
                  values: {
                    done: new Date()
                  }
                }, store.dispatch)
              }
            
              reject()
            }
            catch (e) {
              //afficher l'erreur
              store.dispatch(errorActionCreator())
            }
            finally {
              progress.handleFulfill()
            }
          }
        }]),
      ],
      actionTitle: task.id ? i18n.t('common:interface.edit') : i18n.t('common:interface.add'),
      action: task.done ? undefined : async (values, progress) => {      
        
        try {
          progress.handleTrigger()
          console.log('handle submit')
          const values =  await submitRef.current()
          if(!values) return;

          let promise;

          if(task && task.id) {
            promise = putTaskRoutinePromiseCreator({values, id: task.id}, store.dispatch)
          }
          else {
            promise = postTaskRoutinePromiseCreator({ values }, store.dispatch)
          }

          await promise; 
          console.log('after submit')
    
          return true
        }
        catch (e) {
          //afficher l'erreur
          store.dispatch(errorActionCreator())
          return false
        }
        finally {
          progress.handleFulfill()
        }
     
      }
    })
  )
}



export const deleteTaskFormActionCreator = (task, parentAlertId) => (
  alertRoutine.show({
    type: 'dialog',
    maxWidth: 'xs',
    parent: parentAlertId,
    title: i18n.t('task.delete task'),
    content: i18n.t('task.delete task detail'),
    action: async (values) => {
      
      try {
        await deleteTaskRoutinePromiseCreator({
          id: task.id,
        }, store.dispatch)    
        return true
      }
      catch (e) {
        //afficher l'erreur
        store.dispatch(errorActionCreator())
        return false
      }
      finally {
      }         
    }
  })
)

const TasksList = ({selector, parentAlertId}) => {
  const dispatch = useDispatch()
  const {t} = useTranslation()
  const {moment} = useContext(MuiPickersContext)
  const today = moment().startOf('day')

  const tasks = useSelector(selector)

  return (
    <Table>
      <TableBody>
        {
          tasks.map(task =>
            <TableRow key={task.id} hover style={{cursor: 'pointer'}} onClick={() => {dispatch(taskFormActionCreator(task, parentAlertId))}}>
              <TableCell style={{width:0}} >
                {
                  task.done ?
                    <Box color="success.main"><AssignmentTurnedInOutlined/></Box> :
                    task.diff > 0 ? <Box color="warning.main"><AssignmentLateOutlined/></Box> :
                      false
                }
              </TableCell>
              <TableCell style={{width:0}} >
                {moment(task.display_date).format('L')}
              </TableCell>
              <TableCell style={{width:0, whiteSpace: 'nowrap'}} > 
                {
                  task.display_date === today.format('YYYY-MM-DD')  ? 
                    t('common:button.today') : moment(task.display_date, "YYYY-MM-DD").from(today)
                }
              </TableCell>
              <TableCell>
                {task.diff > 0 ? t(`tasks.booklet title`, {count: task.diff, booklet: task.booklet}) : task.booklet}
              </TableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  )
}

export const tasksLateAlertActionCreator = (patientId) => {
  const lateTasks = lateTaskSelector(store.getState(), patientId)
  const selector = (state) => lateTaskSelector(state, patientId)
  const alertId = v4()
  if(lateTasks.length)
    return alertRoutine.show({
      id: alertId,
      type: 'dialog',
      noPaddingContent: true,
      //maxWidth: 'xs',
      title: i18n.t('tasks.Late tasks'),
      content: <TasksList parentAlertId={alertId} selector={selector}/>,
    })
  else return {
    type: "NONE"
  }
}

export const tasksPatientListAlertActionCreator = (patientId) => {
  

  const selector = (state) => (tasksPatientSelector(state, patientId) || []).sort((a,b) => {
    if((a.done || b.done ) && a.done !== b.done) {
      if(a.done && b.done)
        return a.display_date === b.display_date ? (a.diff > b.diff ? -1 : 1)
        :  a.display_date > b.display_date ? 1 : -1
      else if(a.done)
        return -1
      else
        return 1
    }
    else {
      return a.display_date === b.display_date ? (a.diff > b.diff ? -1 : 1)
        :  a.display_date > b.display_date ? 1 : -1
    }
  })
  
  const alertId = v4()
  return alertRoutine.show({
    id: alertId,
    type: 'dialog',
    noPaddingContent: true,
    //maxWidth: 'xs',
    title: i18n.t('tasks.List patient tasks'),
    content: <TasksList selector={selector} parentAlertId={alertId} />,
  })
}
